/* ==========================================================================
   RezmagCards — shared theme behavior
   The tilt effect, foil sheen, and scroll-reveal are pure CSS/JS from the
   mockups and drop in basically unchanged. Cart interactions now hit
   Shopify's real /cart/add.js endpoint instead of the mockups' fake demo.
   ========================================================================== */

(function () {
  'use strict';

  /* ---- foil-tilt + sheen, delegated so it works on cards added later ---- */
  function bindTilt(card) {
    if (card.dataset.tiltBound) return;
    card.dataset.tiltBound = 'true';
    card.addEventListener('mousemove', function (e) {
      var r = card.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width;
      var py = (e.clientY - r.top) / r.height;
      var rx = (py - 0.5) * -12;
      var ry = (px - 0.5) * 12;
      card.style.transform = 'rotateX(' + rx + 'deg) rotateY(' + ry + 'deg) scale(1.02)';
      card.style.setProperty('--px', (px * 100) + '%');
      card.style.setProperty('--py', (py * 100) + '%');
      card.style.setProperty('--ang', (px * 360));
    });
    card.addEventListener('mouseleave', function () {
      card.style.transform = 'rotateX(0) rotateY(0) scale(1)';
    });
  }

  function bindAllTilt(root) {
    (root || document).querySelectorAll('.card').forEach(bindTilt);
  }

  /* ---- scroll reveal for .slot grids ---- */
  var revealObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) entry.target.classList.add('in');
    });
  }, { threshold: 0.15 });

  function bindReveal(root) {
    (root || document).querySelectorAll('.slot:not(.in)').forEach(function (s) {
      revealObserver.observe(s);
    });
  }

  /* ---- kinetic headline letters (home hero) ---- */
  function initKinetic() {
    document.querySelectorAll('[data-kinetic-text]').forEach(function (el) {
      if (el.dataset.kineticBound) return;
      el.dataset.kineticBound = 'true';
      var word = el.textContent.trim();
      el.textContent = '';
      Array.from(word).forEach(function (ch) {
        var span = document.createElement('span');
        span.textContent = ch;
        el.appendChild(span);
      });
    });
  }

  /* ---- cart count pulse, fired after any successful /cart/add.js ---- */
  function pulseCartCount(newCount) {
    var el = document.getElementById('cart-count');
    if (!el) return;
    if (typeof newCount === 'number') el.textContent = newCount;
    el.classList.add('pulse');
    setTimeout(function () { el.classList.remove('pulse'); }, 1600);
  }
  window.RezmagCards = window.RezmagCards || {};
  window.RezmagCards.pulseCartCount = pulseCartCount;
  window.RezmagCards.bindAllTilt = bindAllTilt;
  window.RezmagCards.bindReveal = bindReveal;

  document.addEventListener('DOMContentLoaded', function () {
    initKinetic();
    bindAllTilt();
    bindReveal();
  });
})();
